export enum COUNTRY_POLLING_TIMEOUT {
  COL = 120,
  DEFAULT = 90
}

export const COUNTRY_POLLING_DELAY = 4.5
